document.addEventListener('DOMContentLoaded', () => {
    const countdowns = document.querySelectorAll('[data-countdown]');
    if (!countdowns.length) return;

    countdowns.forEach((block) => {
        const endValue = block.getAttribute('data-countdown-end');
        const timeEl = block.querySelector('[data-countdown-time]');
        if (!endValue || !timeEl) return;

        const endDate = new Date(endValue).getTime();
        if (Number.isNaN(endDate)) {
            timeEl.textContent = '-';
            return;
        }

        function updateCountdown() {
            const now = new Date().getTime();
            const diff = endDate - now;

            if (diff <= 0) {
                timeEl.textContent = 'Finalizada';
                block.classList.add('is-finished');
                return;
            }

            const days = Math.floor(diff / (1000 * 60 * 60 * 24));
            const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
            const minutes = Math.floor((diff / (1000 * 60)) % 60);
            const seconds = Math.floor((diff / 1000) % 60);

            if (days > 0) {
                timeEl.textContent = `${days}d ${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m`;
            } else {
                timeEl.textContent = `${String(hours).padStart(2, '0')}h ${String(minutes).padStart(2, '0')}m ${String(seconds).padStart(2, '0')}s`;
            }
        }

        updateCountdown();
        setInterval(updateCountdown, 1000);
    });
});